import { InitializeFromIframeDataIfNeeded } from "./iframe-initializer.js";
import { UpdateSelectedLanguage } from "./localization.js";
import { InitializeScene } from "./scene-3d.js";
import { InitializeLandmarkSceneModule } from "./scenes/landmark-edit-scene.js";
import { InitializeSettleSceneModule } from "./scenes/settle-foot-scan-scene.js";
import { InitializeCustomElements } from "./ui/custom-elements.js";
import { InitializeGenericUI } from "./ui/generic-ui.js";
import { InitializeToolsUIData } from "./ui/tools-data.js";

InitializeCustomElements();
InitializeToolsUIData();
InitializeGenericUI();
const loadScenePromise = InitializeScene();
InitializeSettleSceneModule();
InitializeLandmarkSceneModule();

const loadLanguagesPromise = UpdateSelectedLanguage(true);

await Promise.all([loadScenePromise, loadLanguagesPromise]);

await InitializeFromIframeDataIfNeeded();

// Hide loading overlay
const loadingOverlay = document.querySelector("#loading-overlay")!;
loadingOverlay.classList.add("hidden");
